import { movingAverageLight as mal } from "@ixfx/numbers";
import { isPoint3d } from "./guard.js";
export function averager(kind, opts) {
    let x;
    let y;
    let z;
    switch (kind) {
        case `moving-average-light`:
            const scaling = opts.scaling ?? 3;
            x = mal(scaling);
            y = mal(scaling);
            z = mal(scaling);
            break;
        default:
            throw new Error(`Unknown averaging kind '${kind}'. Expected: 'moving-average-light'`);
    }
    return (point) => {
        const ax = x(point.x);
        const ay = y(point.y);
        if (isPoint3d(point)) {
            const az = z(point.z);
            return Object.freeze({
                x: ax,
                y: ay,
                z: az
            });
        }
        else {
            return Object.freeze({
                x: ax,
                y: ay
            });
        }
    };
}
